// extracted by mini-css-extract-plugin
export default {"create-card-settings":"CreateCardSettings_create-card-settings__9-X3a","create-card-settings__tags":"CreateCardSettings_create-card-settings__tags__yEOjR"};